var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrganizacion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 151,
    height: 54,
    viewBox: "0 0 151 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6768",
    "data-name": "Grupo 6768",
    transform: "translate(-12 -56)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "caja-de-oficina",
    transform: "translate(12 55.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons_5_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1927",
    "data-name": "Grupo 1927"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_391",
    "data-name": "Trazado 391",
    d: "M136.342,165.213h22.316a3.106,3.106,0,1,0,0-6.211H136.342a3.106,3.106,0,1,0,0,6.211Z",
    transform: "translate(-116.236 -142.278)",
    fill: "#86888b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_2674",
    "data-name": "Rect\\xE1ngulo 2674",
    transform: "translate(4 9.998)",
    fill: "none",
    stroke: "#003082",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 45,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 51,
    height: 42,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_2675",
    "data-name": "Rect\\xE1ngulo 2675",
    transform: "translate(0 0.998)",
    fill: "none",
    stroke: "#003082",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,0H57a5,5,0,0,1,5,5v7a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V5A5,5,0,0,1,5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,1.5H57A3.5,3.5,0,0,1,60.5,5V9A1.5,1.5,0,0,1,59,10.5H3A1.5,1.5,0,0,1,1.5,9V5A3.5,3.5,0,0,1,5,1.5Z",
    fill: "none"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "caja-de-oficina-2",
    "data-name": "caja-de-oficina",
    transform: "translate(75 64.502)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons_5_2",
    "data-name": "Icons_5_",
    transform: "translate(0 0.998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1927-2",
    "data-name": "Grupo 1927"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_391-2",
    "data-name": "Trazado 391",
    d: "M135.8,164.121h18.39a2.559,2.559,0,1,0,0-5.119H135.8a2.559,2.559,0,1,0,0,5.119Z",
    transform: "translate(-119.227 -146.043)",
    fill: "#86888b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_2674-2",
    "data-name": "Rect\\xE1ngulo 2674",
    transform: "translate(3 7.5)",
    fill: "none",
    stroke: "#003082",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 37,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 42,
    height: 34,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_2675-2",
    "data-name": "Rect\\xE1ngulo 2675",
    transform: "translate(0 1.5)",
    fill: "none",
    stroke: "#003082",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,0H47a4,4,0,0,1,4,4V9a0,0,0,0,1,0,0H0A0,0,0,0,1,0,9V4A4,4,0,0,1,4,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,1.5H47A2.5,2.5,0,0,1,49.5,4V6A1.5,1.5,0,0,1,48,7.5H3A1.5,1.5,0,0,1,1.5,6V4A2.5,2.5,0,0,1,4,1.5Z",
    fill: "none"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "caja-de-oficina-3",
    "data-name": "caja-de-oficina",
    transform: "translate(126 76.624)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons_5_3",
    "data-name": "Icons_5_",
    transform: "translate(0 1.498)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1927-3",
    "data-name": "Grupo 1927",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_391-3",
    "data-name": "Trazado 391",
    d: "M135.09,162.71h13.323a1.854,1.854,0,1,0,0-3.708H135.09a1.854,1.854,0,1,0,0,3.708Z",
    transform: "translate(-123.087 -149.975)",
    fill: "#86888b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_2674-3",
    "data-name": "Rect\\xE1ngulo 2674",
    transform: "translate(2 4.878)",
    fill: "none",
    stroke: "#003082",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 27,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 31,
    height: 25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_2675-3",
    "data-name": "Rect\\xE1ngulo 2675",
    transform: "translate(0 -0.122)",
    fill: "none",
    stroke: "#003082",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,0H34a3,3,0,0,1,3,3V7a0,0,0,0,1,0,0H0A0,0,0,0,1,0,7V3A3,3,0,0,1,3,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,1H34a2,2,0,0,1,2,2V5a1,1,0,0,1-1,1H2A1,1,0,0,1,1,5V3A2,2,0,0,1,3,1Z",
    fill: "none"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganizacion);
export default __webpack_public_path__ + "static/media/organizacion.fc5b23b49a426e07e5a77cea43616d2b.svg";
export { ForwardRef as ReactComponent };